export default __webpack_public_path__ + "static/media/access_logo.e65abf27.png";